module.exports = __webpack_public_path__ + "img/prt_tape.67a5cb95.png";